var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorBeverage2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#5475c2",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 462.9 462.9",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -540.36)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M359.45,697.26L359.45,697.26l-18.1,0v-17.4c0-24.3-9.7-46.9-27.4-63.8c-16.8-16-38.9-25-62.6-25.8l3-27.9v-0.8 c0-3,4-6.2,7.9-6.2h62.7v-15h-62.7c-12,0-22.6,9.6-22.9,20.7l-3.1,29h-22.7c-51.6,0-92,39.4-92,89.6v17.4h-18.1 c-4.1,0-7.5,3.4-7.5,7.5v42.3c0,4.1,3.4,7.5,7.5,7.5h18.8l21.1,213.5c0,0.1,0,0.3,0.1,0.4c3.1,19.6,20.4,35,39.4,35h96 c20.5,0,37.8-15.6,39.5-35.4l22.3-213.5h18.8c4.1,0,7.5-3.4,7.5-7.5v-42.3C366.95,700.66,363.55,697.26,359.45,697.26z  M249.65,605.26c43.1,0.8,76.7,33.3,76.7,74.6h0v17.4h-86.6L249.65,605.26z M136.55,679.86c0-41.9,33.8-74.6,77-74.6h21.1 l-9.9,92h-88.2V679.86z M303.35,966.56L303.35,966.56c0,0.1,0,0.1,0,0.2c-1,12.2-11.7,21.7-24.5,21.7h-96 c-11.7,0-22.5-9.7-24.6-22.1l-20.9-211.8h188.2L303.35,966.56z M351.95,739.56L351.95,739.56h-241v-27.3h18.1h204.8h18.1V739.56z ",
    fill: "#5475c2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.85,953.56c0.1,0.1,0.1,0.2,0.1,0.3c2,10,10.5,17.2,20.1,17.2h23l0,0c4.2,0,7.5-3.3,7.5-7.5c0-4.1-3.4-7.5-7.5-7.5 h-23c-2.8,0-4.8-2.5-5.4-5.1l-6.4-38.4c-0.7-4.1-4.5-6.9-8.6-6.2c-4.1,0.7-6.9,4.5-6.2,8.6L172.85,953.56z",
    fill: "#5475c2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorBeverage2);
export default __webpack_public_path__ + "static/media/color_beverage2.ca894d7e6a766b0bbcf70ae77e54fb59.svg";
export { ForwardRef as ReactComponent };